import React from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import InputName from "../../common/Input/InputName";
import InputEmail from "../../common/Input/InputEmail";
import InputNumber from "../../common/Input/InputPhNumber";
const AddUpdateClinicUser = ({
  showModal,
  setModalVisible,
  handleChange,
  modalAction,
  formData,
  setFormData,
  handleAddOrUpdateAccount,
  handleRoleChange,
  roles,
  setInputError,
  clinicInfo,
}) => {
  return (
    <Modal
      centered
      show={showModal}
      onHide={() => setModalVisible(false)}
      size="md"
    >
      <div className="modal-header">
        <h5 className="modal-title">
          {modalAction === "create" ? "Add clinicUser" : "Update clinicUser"}
        </h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => setModalVisible(false)}
        ></button>
      </div>
      <div className="modal-body">
        <form onSubmit={handleAddOrUpdateAccount}>
          <div className="row">
            <div className="col-xl-12">
              <div className="form-group">
                <InputName
                  name="name"
                  value={formData?.name}
                  onChange={handleChange}
                  placeholder=" Enter Name"
                  label="Name"
                  setInputNameError={setInputError}
                  readOnly={modalAction === "edit"}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <InputNumber
                  name="phone"
                  value={formData?.phone}
                  onChange={handleChange}
                  label="Phone *"
                  placeholder="Enter Mobile Number"
                  setInputNumberError={setInputError}
                  readOnly={modalAction === "edit"}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <InputEmail
                  name="email"
                  value={formData?.email}
                  onChange={handleChange}
                  label="Email *"
                  placeholder="Enter Email"
                  setInputEmailError={setInputError}
                  readOnly={modalAction === "edit"}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="form-group">
                <label className="col-form-label">Role *</label>
                <Select
                  isMulti
                  value={formData?.role || []}
                  placeholder="Please select role"
                  onChange={(selectedOption) =>
                    handleRoleChange(selectedOption, "role")
                  }
                  options={roles?.map((item) => ({
                    value: item?._id,
                    label: item?.name,
                  }))}
                />
              </div>
            </div>
            {clinicInfo[0]?.isAdmin === true && (
              <div className="col-xl-12">
                <div className="form-group form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="isAdmin"
                    name="isAdmin"
                    checked={formData?.isAdmin || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        isAdmin: e.target.checked,
                      }))
                    }
                  />

                  <label className="form-check-label" htmlFor="isAdmin">
                    Is Admin
                  </label>
                </div>
              </div>
            )}
            <div className="col-xl-12">
              <div className="form-group">
                <label className="col-form-label">Password *</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder="Enter Password"
                  name="password"
                  value={formData?.password}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="col-xl-12">
              <div className="form-group d-flex align-items-center">
                <label htmlFor="status" className="col-form-label me-3">
                  Status:
                </label>
                {["Active", "Inactive", "Deleted"].map((status) => (
                  <div className="form-check me-3" key={status}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      id={status.toLowerCase()}
                      value={status}
                      checked={formData?.status === status}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={status.toLowerCase()}
                    >
                      {status}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setModalVisible(false)}
            >
              Close
            </button>
            <button type="submit" className="btn btn-success">
              {modalAction === "create"
                ? "Add ClinicUser"
                : "Update ClinicUser"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddUpdateClinicUser;
